import React, { Component } from 'react';
import PropTypes from 'prop-types'; // ES6
import { Card } from 'antd';

import ObservacioIntroduccioVariable from './observacioIntroduccioVariable';

const CODI_MOMENT_DE_24H = [4, 5];  //24h, Acum. dia pluviomètric

class ObservacioIntroduccioGrupVariables extends Component {

    render() {
        let variables24h = [];
        let variablesDiaACtual = [];
        const variablesGrup = this.props.variables;
        const periodeSeleccionat = this.props.periodeSeleccionat;

        variablesGrup.forEach((variable, index) => {
            const variableRow = <ObservacioIntroduccioVariable key={variable.nomVariable + '-' + index} variable={variable} />;

            if (CODI_MOMENT_DE_24H.indexOf(variable.codiMoment) > -1) {
                variables24h.push(variableRow);
            } else {
                variablesDiaACtual.push(variableRow);
            }
        });

        const card24h = renderMomentCard('Darreres 24h', variables24h);
        const cardPeriode = renderMomentCard(periodeSeleccionat, variablesDiaACtual);

        return (
            <div>
                {cardPeriode}
                {card24h}
            </div>
        );
    }
}

/**
 * Renderitza un element
 * @param text
 * @param variables
 * @returns {*}
 */
function renderMomentCard(text, variables) {

    if (variables.length === 0) {
        return null;
    }

    return (
        <Card title={text} bordered={false} className='observacio-introduccio-grup-variables'>
            { variables }
        </Card>
    );
}

ObservacioIntroduccioGrupVariables.propTypes = {
    variables: PropTypes.array,
    periodeSeleccionat: PropTypes.string,
};

export default ObservacioIntroduccioGrupVariables;


// WEBPACK FOOTER //
// ./src/components/observacio/observacioIntroduccioGrupVariables.js